import { TrackingPayload } from "website_script/lib/tracking"
import { postIframeMessage } from "website_script/lib/iframeMessaging"

/**
 * Sends message out of iframe to the dealers page, then to be sent to the tracking endpoint
 */
export function trackFunction(payload: TrackingPayload) {
  postIframeMessage(
    window.parent,
    {
      kind: "AuTracker.eventFromIframe",
      ...payload,
    },
    "*",
    true
  )
}
